import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const merchandisingAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: FeatureToggle.PromotedPlacements,
  permissions: Permission.PromotedPlacements,
}
